<template>
  <div>
    <div class="columns is-vcentered is-gapless is-border-bottom has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns ">
          <a @click="tab = 'future'" :class="{'is-active': tab === 'future'}"
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">
            À venir ({{futureRdvs.length}})
          </a>
          <a @click="tab = 'past'" :class="{'is-active': tab === 'past'}"
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">
            Historique ({{pastRdvs.length}})
          </a>
          <a @click="tab = 'canceled'" :class="{'is-active': tab === 'canceled'}"
            class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">
            Annulés et reportés ({{canceledRdvs.length}})
          </a>
        </div>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a @click="newRdv" class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey has-text-normal">
          <span class="icon"><i class="fal fa-calendar-plus"></i></span>
          <span>Créer un rdv</span>
        </a>
      </div>
    </div>
    <table
      class="table is-fullwidth is-hoverable is-last-fixed-small is-marginless-bottom is-radius-bottom-left is-radius-bottom-right has-actionsontd">
      <thead>
      <tr class="is-size-6">
        <th>Statut</th>
        <th>Date</th>
        <th>Type</th>
        <th>Participant</th>
        <th>Contact</th>
        <th>Adresse</th>
        <th>Invités</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="r in rdvs" :key="r.pk" class="is-size-6">
        <td>
          <span v-if="r.successful || r.canceled || r.deferred">
            <span class="tag is-success" v-if="r.successful">Effectué</span>
            <span class="tag is-danger" v-if="r.canceled">Annulé</span>
            <span class="tag is-warning" v-if="r.deferred">Reporté</span>
          </span>
          <span v-else>-</span>
        </td>
        <td class="is-narrow">{{r.date | prettyFullDatetime}}</td>
        <td>{{r.rdv_type}}</td>
        <td>
          <router-link :to="{name: 'ContactVue', params: {id: r.seller}}">{{r.seller_name || '-' | smallName}}
          </router-link>
        </td>
        <td>
          <router-link :to="{name: 'ContactVue', params: {id: r.contact}}">{{r.contact_name || '-' | smallName}}
          </router-link>
        </td>
        <td>
          <span
            v-if="r.address && (r.address.zip_code || r.address.city)">{{r.address.zip_code}} {{r.address.city}}</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="r.guests_name && r.guests_name.length">{{r.guests_name.join(', ')}}</span>
          <span v-else>-</span>
        </td>
        <td class="has-text-centered actions">
          <display-button-list :buttons="rdvButtonList" :data="r"></display-button-list>
        </td>
      </tr>
      <tr v-if="rdvs.length < 3" class="empty">
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import moment from 'moment'
  import { sortBy } from 'lodash'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'UserRdvList',
    data () {
      return {
        // authorRdv: [],
        tab: 'future',
        rdvButtonList: [
          {
            action: (id, data) => {
              let day = moment(data.date).format('DD')
              let month = moment(data.date).format('MM')
              let year = moment(data.date).format('YYYY')
              this.$router.push({name: 'CalendarDayView', query: {day, month, year}})
            },
            icon: 'fa-eye',
            text: 'Voir'
          }
        ]
      }
    },
    props: {
      sourceRdvs: {
        type: Array,
        required: true,
        default: []
      },
      sourceAuthorRdvs: {
        type: Array,
        required: true,
        default: []
      }
    },
    computed: {
      ...mapState(['currentUser']),
      ...mapGetters(['currentUserPk']),
      rdvs () {
        if (this.tab === 'future') {
          return this.futureRdvs
        } else if (this.tab === 'canceled') {
          return this.canceledRdvs
        } else {
          return this.pastRdvs
        }
      },
      id () {
        if (this.$route.params.id === 'me') {
          return this.currentUserPk
        } else {
          return this.$route.params.id
        }
      },
      sortedRdvs () {
        return sortBy(this.allRdvs, x => new Date(x.date)).reverse()
      },
      pastRdvs () {
        return this.sortedRdvs.filter(x => new Date(x.date).getTime() < Date.now() && !x.canceled && !x.deferred)
      },
      futureRdvs () {
        let rdvs = this.sortedRdvs.map(x => {
          let y = Object.assign({}, x)
          y._date = moment.utc(x.date)
          return y
        })
        const today = moment.utc()
        return rdvs.filter(x => x._date.diff(today) > 0 && !x.canceled && !x.deferred).reverse()
      },
      canceledRdvs () {
        return this.sortedRdvs.filter(x => x.canceled || x.deferred)
      },
      allRdvs () {
        let rdv = []
        this.sourceRdvs.forEach(x => {
          rdv.push(x)
        })
        if (this.sourceAuthorRdvs && this.sourceAuthorRdvs.length) {
          this.sourceAuthorRdvs.forEach(x => {
            rdv.push(x)
          })
          return rdv
        }
        return rdv
      }
    },
    methods: {
      newRdv () {
        let params = {
          seller: this.id
        }
        this.$router.push({name: 'CalendarCreate', query: params})
      },
      deleteRdv (id) {
        this.$emit('deleteRdv', id)
      }
    },
    created () {
    }
    // mounted() {
    //   this.sourceRdvs.forEach(x => {
    //     console.log('il se passe quelque chose')
    //     this.allRdvs.push(x)
    //   })
    // },
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserRdvList.vue